import React from 'react';
import Navbar from './Navbar';
import DoctorNavbar from './DocNav';
import { useAuth } from './context/AuthContext';

const Layout = ({ children }) => {
    const { currentUser } = useAuth();
    const userRole = currentUser?.role || 'patient';
    
    return (
        <div>
            {userRole === 'doctor' ? <DoctorNavbar /> : <Navbar />}
            <main>
                {children}
            </main>
        </div>
    );
};

export default Layout;